var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramFlight64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./Flight64*",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "Passport",
    transform: "translate(32.890873, 31.890873) rotate(45.000000) translate(-32.890873, -31.890873) translate(5.890873, 3.890873)",
    stroke: "#4F4C4D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,50.909481 L16,54.8195396 L27,52.9862062 L38,54.8195396 L38,50.909481 L31,48.459481 L31,5.00752382 C31,2.78926246 29.2115945,1 27,1 C24.7947023,1 23,2.79600874 23,5.00752382 L23,48.459481 L16,50.909481 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,17.5 L31,28.1868624 L53,32.7701958 L53,26.6666667 L31,17.5 Z",
    id: "Wing",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,17.5 L1,28.1868624 L23,32.7701958 L23,26.6666667 L1,17.5 Z",
    id: "Wing",
    fill: "#FFCC00",
    transform: "translate(12.000000, 25.000000) scale(-1, 1) translate(-12.000000, -25.000000) "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramFlight64);
export default __webpack_public_path__ + "static/media/pictogramFlight64.877ccea06d1175794b27568f7d67dc26.svg";
export { ForwardRef as ReactComponent };